import { Card, styled, Typography } from '@mui/material';

import Button from 'components/Button';

export const Div_RowHeaderWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const Div_RowHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'flex-start',
});

export const Div_ContainerWithEndJustifyContent = styled('div')({
  display: 'flex',
  justifyContent: 'end',
});

export const Div_FiltersWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

export const Div_TableContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'withoutAddButton',
})(({ withoutAddButton, theme }) => ({
  display: 'flex',
  overflow: 'hidden',
  flex: 'auto',
  flexDirection: 'column',
  height: '100%',
  marginBottom: withoutAddButton ? theme.spacing(16) : '0',
}));

export const Div_AddBtnWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  margin: theme.spacing(4, 0),
}));

export const Typography_TableTitle = styled(Typography)(({ theme }) => ({
  marginRight: 'auto',
  marginBottom: theme.spacing(4),
}));

export const Card_TableWrapper = styled(Card)(({ theme }) => ({
  display: 'flex',
  flex: 'auto',
  flexDirection: 'column',
  marginTop: theme.spacing(4),
}));

export const Button_Settings = styled(Button, {
  shouldForwardProp: prop => prop !== 'elevate',
})(({ elevate }) => ({
  zIndex: elevate ? 1301 : 0,
}));
